import { Injector } from '@angular/core';
import { DocumentsService } from '@data-access/documents/services';
import { MimeType } from '@data-access/documents/types';
import { tapResponse } from '@ngrx/operators';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
  withProps,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { IResults } from '@shared/iris.interface';
import { pipe, switchMap } from 'rxjs';

const mimeTypeEntity = () =>
  entityConfig({
    collection: '_mimeType',
    entity: type<MimeType>(),
    selectId: (entity: MimeType) => entity.id,
  });

export const withMimeTypesEntities = (_injector: Injector) => {
  return signalStoreFeature(
    withProps((store) => ({
      store,
    })),
    withEntities(mimeTypeEntity()),
    withMethods(({ store }) => {
      const _fetchMimeTypes = rxMethod<{
        page?: number;
        pageSize?: number;
      }>(
        pipe(
          switchMap((params) => {
            const { page = 1, pageSize = 100 } = params;
            patchState(store, { loading: true });
            const docService = _injector.get(DocumentsService);
            return docService.getMimeTypes(page, pageSize).pipe(
              tapResponse({
                error: (error: Error) => {
                  console.error('Error loading mime types:', error);
                  patchState(store, { loading: false });
                },
                finalize: () => patchState(store, { loading: false }),
                next: (response: IResults<MimeType>) => {
                  if (response?.data && Array.isArray(response.data)) {
                    patchState(
                      store,
                      setAllEntities(response.data, mimeTypeEntity()),
                    );
                  }
                },
              }),
            );
          }),
        ),
      );
      return {
        setMimeTypes: (params?: { page?: number; pageSize?: number }) => {
          _fetchMimeTypes(params || {});
        },
      };
    }),
  );
};
